import { createContext } from 'react';

export type ContextType = string | undefined;
export const FlashMessageContext = createContext<ContextType>(undefined);
